import React from 'react'

/**
 * AutoFitText (editor)
 * --------------------
 * Renders text at its EXACT configured fontSize. The editor's model is:
 *   - The user sets the font size; the element BOX (width/height) auto-grows to
 *     contain the text at that size (handled by the auto-grow logic in
 *     WorkspacePage when fontSize / content / font changes). The width/height a
 *     user ends up with is the "max box".
 *   - At render time in the video_worker, that box is treated as the MAX and the
 *     actual (possibly longer, variable) content is shrunk to fit it.
 *
 * So the editor NEVER shrinks the font — doing so is what made the Size control
 * appear not to work. This component is now a thin passthrough that hands the
 * base font size and a ref straight through, preserving the existing
 * function-as-children call sites.
 */
const AutoFitText = ({ baseFontSize, children }) => {
  const boxRef = React.useRef(null)
  return children(baseFontSize, boxRef)
}

export default AutoFitText
